import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue-demi';
import {
  AbSection,
  AbContainer,
  AbTitle,
  AbDescription,
  AbButton,
} from '../../../ui';
import {
  useSectionAnalytics,
} from '../../../../analytics';
import { CdnImg } from '@webplatform/cdn-image';
import { Spacing } from '../../../../helpers/shared-props';
import HtmlRenderer from '../../../ui/HtmlRenderer.vue';

interface Props {
  data: {
    analytics_placement?: string | null;
    id?: string | null;
    title?: string | null;
    description?: string | null;
    subtext?: string | null;
    link?: {
      creative_name?: string | null;
      text: string;
      src?: string | null;
    } | null;
    banner?: {
      src?: string | null;
      alt?: string | null;
      mobile?: {
        src?: string | null;
      } | null;
    } | null;
    spacing?: Spacing | null;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CtaSectionBanner',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: {
    analytics_placement?: string | null;
    id?: string | null;
    title?: string | null;
    description?: string | null;
    subtext?: string | null;
    link?: {
      creative_name?: string | null;
      text: string;
      src?: string | null;
    } | null;
    banner?: {
      src?: string | null;
      alt?: string | null;
      mobile?: {
        src?: string | null;
      } | null;
    } | null;
    spacing?: Spacing | null;
  };
};



const bannerRef = ref<HTMLElement | null>(null);

const { trackSelectItem } = useSectionAnalytics(
  bannerRef,
  {
    placement: props.data.analytics_placement ?? '',
    items: [
      {
        destination_url: props.data.link?.src ?? '',
        creative_name: props.data.link?.creative_name ?? '',
      },
    ],
  },
  { sectionName: 'CtaSectionBanner'}
);

const handleButtonClick = () => {
  trackSelectItem();
};

return { __sfc: true,props, bannerRef, trackSelectItem, handleButtonClick, AbSection, AbContainer, AbTitle, AbDescription, AbButton, CdnImg, HtmlRenderer }
}

})